import { Badge } from '@monksflow/monks-ui';
import { XIcon, type LucideIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export interface BriefIntakeChipProps {
  icon: LucideIcon;
  label: string;
  onRemove: () => void;
}

export const BriefIntakeChip = ({ icon: Icon, label, onRemove }: BriefIntakeChipProps) => {
  const { t } = useTranslation('briefs');

  return (
    <Badge variant="secondary" roundness="full" className="gap-1.5 bg-secondary py-1.5 pl-2.5 pr-2">
      <Icon className="size-3 shrink-0" aria-hidden />
      <span className="max-w-40 truncate">{label}</span>
      <button
        type="button"
        aria-label={t('briefGeneration.briefIntakeChip.remove', { label })}
        onClick={onRemove}
        className="rounded-full p-0.5 hover:bg-background/60"
      >
        <XIcon />
      </button>
    </Badge>
  );
};
